import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Clock, Send } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-gray-50" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-75">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-76">
            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-77">
              Da el primer paso
            </h2>
            <p className="text-lg text-gray-600 mb-10" data-id="element-78">
              No tienes que hacerlo sola/o. Estoy aquí para acompañarte.
            </p>

            {/* Phone Card */}
            <div className="bg-teal-700 rounded-xl p-8 text-white mb-8 shadow-sm" data-id="element-79">
              <Phone className="w-8 h-8 mb-4 text-teal-200" data-id="element-80" />
              <h3 className="font-serif text-2xl font-bold mb-2" data-id="element-81">
                ¿Prefieres llamar?
              </h3>
              <p className="text-teal-100 mb-6" data-id="element-82">
                Estoy disponible para orientarte.
              </p>
              <a href="tel:6103747035" className="inline-flex items-center justify-center w-full px-6 py-3 bg-white text-teal-700 font-bold rounded-lg hover:bg-gray-50 transition-colors" data-id="element-83">
                Llamar al 610-374-7035
              </a>
            </div>

            <div className="space-y-6" data-id="element-84">
              <div className="flex items-start" data-id="element-85">
                <MapPin className="w-6 h-6 text-teal-700 mr-4 mt-1" data-id="element-86" />
                <div data-id="element-87">
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-88">Ubicación</h3>
                  <p className="text-gray-600" data-id="element-89">Reading Behavioral Health</p>
                  <p className="text-gray-600" data-id="element-90">Reading, Berks County, PA</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-91">
                <Clock className="w-6 h-6 text-teal-700 mr-4 mt-1" data-id="element-92" />
                <div data-id="element-93">
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-94">Horario</h3>
                  <p className="text-gray-600" data-id="element-95">Lunes a Viernes</p>
                  <p className="text-gray-600" data-id="element-96">8:00 AM – 4:00 PM</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl shadow-sm p-8 border border-gray-200" data-id="element-97">
            <h3 className="font-serif text-2xl font-bold text-gray-900 mb-6" data-id="element-98">
              Envíame un mensaje
            </h3>
            <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-99">
              <div data-id="element-100">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-101">
                  Nombre completo
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-700 focus:border-teal-700 outline-none transition-all" placeholder="Tu nombre" data-id="element-102" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-103">
                <div data-id="element-104">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-105">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-700 focus:border-teal-700 outline-none transition-all" placeholder="tucorreo@ejemplo.com" data-id="element-106" />
                </div>
                <div data-id="element-107">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-108">
                    Teléfono
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-700 focus:border-teal-700 outline-none transition-all" placeholder="(000) 000-0000" data-id="element-109" />
                </div>
              </div>

              <div data-id="element-110">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-111">
                  Mensaje
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-700 focus:border-teal-700 outline-none transition-all" placeholder="¿En qué puedo ayudarte?" data-id="element-112"></textarea>
              </div>

              <button type="submit" className="w-full flex items-center justify-center px-6 py-3.5 text-base font-medium rounded-lg text-white bg-teal-700 hover:bg-teal-800 transition-colors shadow-sm" data-id="element-113">
                <Send className="w-5 h-5 mr-2" data-id="element-114" />
                Enviar mensaje
              </button>

              <p className="text-xs text-gray-500 text-center" data-id="element-115">
                Tu información es confidencial.
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}